import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Unconstrained Delegation field definition
 * Boolean field with Yes/No dropdown for unconstrained delegation status filtering
 */
export const ADObjectUnconstrainedDelegation =
  createBooleanSimpleFilterDefinition(
    'unconstraineddelegation',
    'Unconstrained Delegation'
  );
